/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consult_Q1_AInputs */

const en_consult_q1_a = /** @type {(inputs: Consult_Q1_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Running, with paying customers`)
};

const id_consult_q1_a = /** @type {(inputs: Consult_Q1_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sudah jalan dan punya pelanggan`)
};

/**
* | output |
* | --- |
* | "Running, with paying customers" |
*
* @param {Consult_Q1_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const consult_q1_a = /** @type {((inputs?: Consult_Q1_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consult_Q1_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_consult_q1_a(inputs)
	return en_consult_q1_a(inputs)
});